var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeSizeSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#70748B",
    d: "m17.354 6.354-11 11M17.354 12.354l-5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeSizeSvg);
export default __webpack_public_path__ + "static/media/changeSizeSvg.acd6c18ea43af03a46a9fd5339a75a9a.svg";
export { ForwardRef as ReactComponent };